import { useQuery } from "@tanstack/react-query";
import apiClient from "../lib/api-client";

// --- Performance ---
interface EndpointPerf {
  endpoint: string;
  count: number;
  avg_ms: number;
  p95_ms: number;
}

interface PerformanceData {
  period_days: number;
  by_endpoint: EndpointPerf[];
}

export function useAdminPerformance(days: number) {
  return useQuery<PerformanceData>({
    queryKey: ["admin", "performance", days],
    queryFn: () =>
      apiClient.get("api/admin/performance", { searchParams: { days } }).json<PerformanceData>(),
  });
}

// --- PDF Stats ---
interface TierStat {
  tier: string;
  attempts: number;
  successes: number;
  avg_ms: number;
}

interface ErrorStat {
  error: string;
  count: number;
}

interface PdfStatsData {
  period_days: number;
  total_attempts: number;
  success_rate: number;
  by_tier: TierStat[];
  common_errors: ErrorStat[];
}

export function useAdminPdfStats(days: number) {
  return useQuery<PdfStatsData>({
    queryKey: ["admin", "pdf-stats", days],
    queryFn: () =>
      apiClient.get("api/admin/pdf-stats", { searchParams: { days } }).json<PdfStatsData>(),
  });
}

// --- Engagement ---
interface TypeCount {
  event_type: string;
  count: number;
}

interface FeatureCount {
  feature: string;
  count: number;
}

interface RouteView {
  route: string;
  views: number;
}

interface EngagementData {
  period_days: number;
  active_users: number;
  total_events: number;
  by_type: TypeCount[];
  feature_usage: FeatureCount[];
  top_routes: RouteView[];
}

export function useAdminEngagement(days: number) {
  return useQuery<EngagementData>({
    queryKey: ["admin", "engagement", days],
    queryFn: () =>
      apiClient.get("api/admin/engagement", { searchParams: { days } }).json<EngagementData>(),
  });
}
